/* global navigator */

export const copyToClipboard = (dataToCopy: object | string) => {
  let textToCopy = ''
  if (typeof dataToCopy === 'string') textToCopy = dataToCopy
  else textToCopy += Object.values(dataToCopy).join('\n')

  navigator.clipboard.writeText(textToCopy)
}
